module.exports = __webpack_public_path__ + "static/img/detail_champs_02.e3d83f8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/projects/champs-ultimate-training-camp-challenge/detail_champs_02.jpg
// module id = 229
// module chunks = 2